if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      filterColourMedia(opener) {
        const gallery = opener.closest('media-gallery');
        const visibleIds = gallery?.dataset.colourFilter === 'true'
          ? new Set(Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]:not([hidden])'))
              .map((item) => item.dataset.mediaId.split('-').pop()))
          : null;
        if (visibleIds && !visibleIds.size) return;

        this.colourMediaStyles = this.colourMediaStyles || new WeakMap();
        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((item) => {
          const previous = this.colourMediaStyles.get(item);
          if (visibleIds && !visibleIds.has(item.dataset.mediaId)) {
            if (!previous) this.colourMediaStyles.set(item, {
              hidden: item.hidden,
              display: item.style.getPropertyValue('display'),
              priority: item.style.getPropertyPriority('display'),
            });
            item.hidden = true;
            item.style.setProperty('display', 'none', 'important');
          } else if (previous) {
            item.hidden = previous.hidden;
            if (previous.display) item.style.setProperty('display', previous.display, previous.priority);
            else item.style.removeProperty('display');
            this.colourMediaStyles.delete(item);
          }
        });
      }

      show(opener) {
        this.filterColourMedia(opener);
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
